import React, {Component, Fragment} from 'react';
import './Modal.css';

class Modal extends Component {

    constructor(props) {
        super(props);
        this.modalContentElem = React.createRef();
    }
    componentDidMount() {
        this.modalContentElem.current.scrollTop = 0;
    }
    componentDidUpdate() {
        this.modalContentElem.current.scrollTop = 0;
    }

    render() {
        const {show, modalClosed, style, iconClose, children} = this.props;
        return (
            <Fragment>
                {show ? <div 
                className="backdrop"
                style={style.backdrop}
                onClick={modalClosed}>
                </div> : null}

                <div 
                    className="modal"
                    style={{
                        transform: show ? 'translateY(0)' : 'translateY(-1000vh)',
                        opacity: show ? '1' : '0',
                        ...style.modal
                }}>
                    <div style={{
                        zIndex:999,
                        cursor:'pointer', 
                        position:'fixed', 
                        top:-30, 
                        right:-30, 
                        width:60, 
                        height:60, 
                        backgroundColor:'black', 
                        color:'white',
                        fontSize:'60px', 
                        borderRadius:2, 
                        lineHeight:'40px', 
                        textAlign:'center',
                        ...style.close
                        }} onClick={modalClosed}>{iconClose}</div>

                    <div className="modal-content" ref={this.modalContentElem}>
                        {children}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Modal;
